import React, { useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/autoplay";

import { LeftArrowIcon, RightArrowIcon } from "../../../assets/svg";

import { SkeletonPopularRetailer } from "../../CommonComponents/SkeletonUI/LandingPageSkeleton";

export default function PopularRetailer({ brandListData }) {
  const swiperRef = useRef(null); // Ref to access the Swiper instance
  const [currentSlide, setCurrentSlide] = useState(0); // Track current slide index

  const totalSlides = brandListData?.length;

  const handlePrev = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slidePrev();
      setCurrentSlide(swiperRef.current.swiper.activeIndex);
    }
  };

  const handleNext = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slideNext();
      setCurrentSlide(swiperRef.current.swiper.activeIndex);
    }
  };

  const responsiveBreakpoints = {
    1300: { slidesPerView: 8, spaceBetween: 16 },
    1280: { slidesPerView: 7, spaceBetween: 16 },
    1024: { slidesPerView: 6, spaceBetween: 16 },
    950: { slidesPerView: 5.5, spaceBetween: 16 },
    850: { slidesPerView: 5, spaceBetween: 16 },
    768: { slidesPerView: 4.5, spaceBetween: 16 },
    767: { slidesPerView: 6, spaceBetween: 16 },
    600: { slidesPerView: 3, spaceBetween: 16 },
    400: { slidesPerView: 3, spaceBetween: 16 },
    350: { slidesPerView: 3, spaceBetween: 16 },
    300: { slidesPerView: 2.5, spaceBetween: 16 },
    0: { slidesPerView: 2.5, spaceBetween: 16 },
  };

  return (
    <>
      {brandListData !== null && totalSlides > 0 ? (
        <div className="container flex flex-col mb-4 mt-8 pl-5 -pr-5 md:px-5 mx-auto relative">
          <div className="flex">
            <div className="font-semibold font-Inter text-xl md:text-3xl">Popular Retailers</div>
            <button onClick={handlePrev} className="carousel-custom-arrow left-arrow">
              <LeftArrowIcon className={`w-[24px] h-[24px] md:w-[35px] md:h-[35px] stroke-[${currentSlide === 0 ? "#737373" : "#000"}]`} />
            </button>

            <button onClick={handleNext} className="carousel-custom-arrow right-arrow">
              <RightArrowIcon className={`w-[24px] h-[24px] md:w-[35px] md:h-[35px] stroke-[${currentSlide === totalSlides - 1 ? "#737373" : "#000"}]`} />
            </button>
          </div>

          <div className="carousel-wrapper">
            <Swiper
              ref={swiperRef}
              modules={[Autoplay, Navigation]}
              spaceBetween={16}
              slidesPerView={8}
              autoplay={{ delay: 5000, disableOnInteraction: false }}
              onSlideChange={(swiper) => setCurrentSlide(swiper.activeIndex)}
              breakpoints={responsiveBreakpoints}
              className="popularRetailerSwipper"
              loop={true}
            >
              {brandListData?.map((item) => (
                <SwiperSlide key={item?.id}>
                  <div className="flex justify-between">
                    <div
                      className="w-[100px] h-[75px] md:w-36 md:h-24 rounded-[10px] bg-contain bg-no-repeat bg-center drop-shadow-lg"
                      style={{ backgroundImage: `url('${item?.logo}')`, backgroundColor: `#${item?.hex_code}` }}
                    >
                      {!item?.logo && (
                        <div className={`font-Inter text-xl text-center flex items-center justify-center h-full ${item?.hex_code === "FFFFFF" ? "text-black" : "text-white"}`}>
                          {item?.name}
                        </div>
                      )}
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      ) : (
        <SkeletonPopularRetailer />
      )}
    </>
  );
}